//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/course/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveCourse: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/course/edit/save", vo, successCallback, failureCallback);
    },
    upload: (file, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "Courses");
        formData.append("field", "Cover");
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    },
};

export default EditService;